import * as React from 'react'

import { isGemPackProduct, StoreOfferProduct } from '@common'
import cx from 'classnames'
import Image from 'next/image'

import BgFlare from '@/assets/images/storefronts/clashofclans/shop_item_bg_flare.png'
import { ClashOfClansContainer } from '@/features/storefronts/_storeBase/card/v2/OfferCard/games/clashofclans/components/ClashOfClansContainer'
import { isScenery, isSkin } from '@/features/storefronts/productFilters'

import { ClashOfClansHeading } from './components/ClashOfClansHeading'
import { ClashOfClansOfferCardContent } from './components/ClashOfClansOfferCardContent'
import { Countdown, Footer, ValueBadge } from '../../../shared'
import { Ribbon, Ribbons } from '../../shared/Ribbons'

import styles from './ClashOfClansOfferCard.module.scss'

type Props = {
  product: StoreOfferProduct
  offerCardType?: 'default' | 'special'
  ribbons: Ribbon[]
}

export function ClashOfClansOfferCard({ product, ribbons, offerCardType }: Props) {
  const isMultiItemOffer = product.contents.length > 1
  const isSpecialOffer = offerCardType === 'special'
  const isSingleSceneryOrSkin = !isMultiItemOffer && (isScenery(product) || isSkin(product))
  const isGemPack = isGemPackProduct(product)

  return (
    <ClashOfClansContainer
      product={product}
      className={cx(styles.Container, {
        [styles.MultiItemContainer]: isMultiItemOffer,
        [styles.SingleItemContainer]: !isMultiItemOffer,
        [styles.SpecialOfferContainer]: isSpecialOffer,
      })}
    >
      {!isSpecialOffer && (isSingleSceneryOrSkin || isGemPack) && (
        <div className={styles.Flare}>
          <Image src={BgFlare} unoptimized alt="product flare" fill sizes="200px" />
        </div>
      )}
      <Countdown product={product as StoreOfferProduct} />
      {ribbons.length === 0 ? <ValueBadge product={product} /> : <Ribbons ribbons={ribbons} />}
      <ClashOfClansHeading product={product} />
      <ClashOfClansOfferCardContent product={product} offerCardType={offerCardType} />
      <Footer product={product} className={styles.Footer} />
    </ClashOfClansContainer>
  )
}
